// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1G9r-","col":"styles_col__V62BJ"};